"use client"
"use client";
import "../chunk-JSBRDJBE.js";

// src/client/scroll-reset.tsx
import { useEffect } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var ScrollReset = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return /* @__PURE__ */ jsx(Fragment, {});
};
var scroll_reset_default = ScrollReset;
export {
  scroll_reset_default as default
};
